module.exports = __webpack_public_path__ + "assets/img/00a62086ea1f948f112480b7f09c9977.d4967d8e.png";